import styled from 'styled-components'

const ContentWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  flex-flow: column nowrap;

  width: 100%;
`

export default ContentWrapper
